module.exports = __webpack_public_path__ + "static/closeup-inside-side-church.784eb1c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/closeup-inside-side-church.jpg
// module id = 93
// module chunks = 35783957827783 82680274759079